import React, { Component } from "react";
import moment from "moment";
import "moment-timezone";
import Highcharts from "highcharts/highstock";
import ReactHighcharts from "react-highcharts//ReactHighstock";
import _ from "lodash";
import "./botChart.css";
import { initiateTracking } from "../../../../../utils/commonUtil";
import { getBotGraphData } from "../../config";
import { fetchBOTData } from "../../actions";
import { connect } from "react-redux";
import loader from "../../../../../assets/icons/loader.gif";
import { PropTypes } from "prop-types";
import { accountSummaryDerivedStates } from "../../selectors";

window.moment = moment;
Highcharts.setOptions({
  time: {
    timezone: "America/New_York"
  },
  lang: {
    rangeSelectorZoom: "",
    rangeSelectorFrom: "From:",
    rangeSelectorTo: "To:",
    numericSymbols: [" k", " m", "b"]
  }
});
let selectedFilter = { value: "" };

export class BOTChart extends Component {
  state = {
    data: this.props.data,
    chartDataMonth: false,
    tabSelectedValue: 0,
    BOTloader: false
  };
  componentDidMount() {
    this.chartDataRender();
    this.selected();
  }

  componentWillReceiveProps(nextProps) {
    this.props = nextProps;
    this.changeStateToFull();
    if (nextProps.isAccountSummaryLoading == true) {
      this.setState((state, props) => ({ BOTloader: true }));
    } else {
      this.setState((state, props) => ({ BOTloader: false }));
    }
  }
  changeStateToFull = () => {
    if (this.props.dataAll.length > 0) {
      this.setState((state, props) => ({ data: this.props.dataAll }));
    }
  };
  chartDataRender = () => {
    if (this.props.data.length > 2) {
      this.setState({
        chartDataMonth: true
      });
    } else {
      this.setState({
        chartDataMonth: false
      });
    }
  };

  annualData = () => {
    let annualData = [];
    this.state.data.map(data => {
      if (window.innerWidth > 767) {
        if (data.annualReport) {
          annualData.push({
            x: data.x,
            title: "Annual Summary",
            Annual: data.annualReport
          });
        }
      } else {
        if (data.annualReport) {
          annualData.push({
            x: data.x,
            title: "SUM",
            Annual: data.annualReport
          });
        }
      }
    });
    return annualData;
  };

  selected = () => {
    let d = moment()
      .subtract(90, "days")
      .format("x");

    let oneYearData = _.filter(this.props.data, function(o) {
      return o.x <= d;
    });
    if (oneYearData.length > 0) {
      selectedFilter.value = 1;
    } else {
      selectedFilter.value = 0;
    }
  };

  threeYearData = n => {
    if (selectedFilter.value <= n + 2)
      this.props.fetchBOTData(getBotGraphData(n * 365));
  };

  handleData = res => {
    let graphData = [];

    res.map(data => {
      graphData.push({
        x: data.x,
        y: data.y,
        marker: {
          enabled: false,
          radius: 2,
          fillColor: "#136878"
        }
      });
    });
    return graphData;
  };

  render() {
    const chartConfig = {
      chart: {
        type: "area",
        panning: false,
        pinchType: false,
        events: {
          load: function() {
            document.addEventListener("scroll", function() {
              let rangeSel = document.getElementsByClassName(
                "range-selector-tooltipBOT"
              );
              if (rangeSel.length > 0) {
                rangeSel[0].style.display = "none";
              }
            });
            document.getElementsByClassName(
              "range-selector-tooltipBOT"
            )[0].style.display = "none";
            if (
              navigator.userAgent.indexOf("Safari") != -1 &&
              navigator.userAgent.indexOf("Chrome") == -1
            ) {
              let windowWidth = window.innerWidth;

              if (windowWidth > 767) {
                document
                  .getElementsByClassName("highcharts-button")[0]
                  .childNodes[1].setAttributeNS(null, "y", 15);
                document
                  .getElementsByClassName("highcharts-button")[3]
                  .childNodes[1].setAttributeNS(null, "y", 16);

                setTimeout(function() {
                  document
                    .getElementsByClassName(
                      "highcharts-range-selector-buttons"
                    )[0]
                    .childNodes[0].setAttributeNS(null, "x", 55);
                }, 100);
              } else {
                return 0;
              }
            }
            let ua = window.navigator.userAgent;
            let msie = ua.indexOf("MSIE ");
            if (msie > 0) {
              let windowWidth = window.innerWidth;
              if (windowWidth > 767) {
                setTimeout(function() {
                  document
                    .getElementsByClassName(
                      "highcharts-range-selector-buttons"
                    )[0]
                    .childNodes[0].setAttributeNS(null, "y", 20);
                  document
                    .getElementsByClassName(
                      "highcharts-label highcharts-range-label"
                    )[0]
                    .childNodes[0].setAttributeNS(null, "x", -5);
                  document
                    .getElementsByClassName(
                      "highcharts-label highcharts-range-label"
                    )[1]
                    .childNodes[0].setAttributeNS(null, "x", -2);
                  document
                    .getElementsByClassName(
                      "highcharts-label highcharts-range-label"
                    )[0]
                    .childNodes[0].setAttributeNS(null, "y", 16);
                  document
                    .getElementsByClassName(
                      "highcharts-label highcharts-range-label"
                    )[1]
                    .childNodes[0].setAttributeNS(null, "y", 17);
                }, 100);
              } else {
                for (
                  let i = 0;
                  i <
                  document.getElementsByClassName("highcharts-button").length;
                  i++
                ) {
                  document
                    .getElementsByClassName("highcharts-button")
                    [i].childNodes[1].setAttributeNS(null, "x", 10);
                }
                setTimeout(function() {
                  document
                    .getElementsByClassName(
                      " highcharts-range-selector-buttons"
                    )[0]
                    .setAttribute("transform", "translate(-15 10)");

                  document
                    .getElementsByClassName("highcharts-input-group")[0]
                    .setAttribute("transform", "translate(0 48)");
                  document
                    .getElementsByClassName(
                      "highcharts-label highcharts-range-label"
                    )[0]
                    .childNodes[0].setAttributeNS(null, "y", 16);
                  document
                    .getElementsByClassName(
                      "highcharts-label highcharts-range-label"
                    )[1]
                    .childNodes[0].setAttributeNS(null, "y", 16);
                }, 100);
              }
            }
            let trident = ua.indexOf("Trident/");
            if (trident > 0) {
              let windowWidth = window.innerWidth;
              // IE 11 => return version number
              if (windowWidth > 767) {
                setTimeout(function() {
                  document
                    .getElementsByClassName(
                      "highcharts-range-selector-buttons"
                    )[0]
                    .childNodes[0].setAttributeNS(null, "y", 20);

                  document
                    .getElementsByClassName(
                      "highcharts-label highcharts-range-label"
                    )[0]
                    .childNodes[0].setAttributeNS(null, "x", -5);
                  document
                    .getElementsByClassName(
                      "highcharts-label highcharts-range-label"
                    )[1]
                    .childNodes[0].setAttributeNS(null, "x", -2);
                  document
                    .getElementsByClassName(
                      "highcharts-label highcharts-range-label"
                    )[0]
                    .childNodes[0].setAttributeNS(null, "y", 16);
                  document
                    .getElementsByClassName(
                      "highcharts-label highcharts-range-label"
                    )[1]
                    .childNodes[0].setAttributeNS(null, "y", 17);
                }, 200);
              } else {
                for (
                  let i = 0;
                  i <
                  document.getElementsByClassName("highcharts-button").length;
                  i++
                ) {
                  document
                    .getElementsByClassName("highcharts-button")
                    [i].childNodes[1].setAttributeNS(null, "x", 10);
                }
                setTimeout(function() {
                  document
                    .getElementsByClassName(
                      " highcharts-range-selector-buttons"
                    )[0]
                    .setAttribute("transform", "translate(-15 10)");

                  document
                    .getElementsByClassName("highcharts-input-group")[0]
                    .setAttribute("transform", "translate(0 48)");
                  document
                    .getElementsByClassName(
                      "highcharts-label highcharts-range-label"
                    )[0]
                    .childNodes[0].setAttributeNS(null, "y", 16);
                  document
                    .getElementsByClassName(
                      "highcharts-label highcharts-range-label"
                    )[1]
                    .childNodes[0].setAttributeNS(null, "y", 16);
                }, 200);
              }
            }

            let edge = ua.indexOf("Edge/");
            if (edge > 0) {
              // Edge (IE 12+) => return version number
            }
            const arr = document.getElementsByClassName(
              "highcharts-button-disabled"
            );

            for (let i = 0; i < arr.length; i++) {
              arr[i].addEventListener("mouseover", function() {
                let pos = this.getBoundingClientRect();
                document.getElementsByClassName(
                  "range-selector-tooltipBOT"
                )[0].style.display = "inline-block";

                document.getElementsByClassName(
                  "range-selector-tooltipBOT"
                )[0].style.top = pos.top - 60 + "px";
                document.getElementsByClassName(
                  "range-selector-tooltipBOT"
                )[0].style.left = pos.left - 78 + "px";
              });

              arr[i].addEventListener("mouseout", function() {
                let pos = this.getBoundingClientRect();
                document.getElementsByClassName(
                  "range-selector-tooltipBOT"
                )[0].style.display = "none";
              });
            }
            for (let i = 0; i < arr.length; i++) {
              arr[i].addEventListener("touchstart", function() {
                let pos = this.getBoundingClientRect();
                document.getElementsByClassName(
                  "range-selector-tooltipBOT"
                )[0].style.display = "inline-block";
                document.getElementsByClassName(
                  "range-selector-tooltipBOT"
                )[0].style.top = pos.top - 90 + "px";
                document.getElementsByClassName(
                  "range-selector-tooltipBOT"
                )[0].style.left = pos.left - 78 + "px";
              });

              arr[i].addEventListener("touchend", function() {
                let pos = this.getBoundingClientRect();
                document.getElementsByClassName(
                  "range-selector-tooltipBOT"
                )[0].style.display = "none";
              });
            }
          }
        }
      },

      rangeSelector: {
        inputEnabled: true,
        inputDateFormat: "%m/%d/%Y",
        inputEditDateFormat: "%m/%d/%Y",
        inputBoxBorderColor: "tranparent",
        allButtonsEnabled: true,
        inputBoxWidth: 80,
        inputBoxHeight: 20,
        inputStyle: {
          color: "#505050",
          fontFamily: "HelveticaNeue-Bold",
          letterSpacing: 0.5,
          fontSize: "16px"
        },
        labelStyle: {
          color: "#505050",
          fontFamily: "HelveticaNeue",
          fontSize: "16px"
        },

        buttons: [
          {
            type: "month",
            count: 1,
            text: "1M",
            events: {
              click: () => {
                if (selectedFilter.value !== 0) {
                  initiateTracking("botEvents", "Account Summary", "", "1m");
                } else {
                }
                selectedFilter.value = 0;
              }
            }
          },
          {
            type: "month",
            count: 3,
            text: "3M",
            events: {
              click: () => {
                if (selectedFilter.value !== 1) {
                  initiateTracking("botEvents", "Account Summary", "", "3m");
                } else {
                }
                selectedFilter.value = 1;
              }
            },
            offsetMin: (function() {
              if (moment.tz.guess(true) != "America/New_York") {
                return 1 * 3600 * 1000;
              }
            })()
          },
          {
            type: "month",
            count: 6,
            text: "6M",
            events: {
              click: () => {
                if (selectedFilter.value !== 2) {
                  initiateTracking("botEvents", "Account Summary", "", "6m");
                } else {
                }
                selectedFilter.value = 2;

                if (this.state.tabSelectedValue < selectedFilter.value) {
                  this.setState((state, props) => ({
                    tabSelectedValue: selectedFilter.value
                  }));
                  this.threeYearData(0.5);
                }
              }
            },
            offsetMin: (function() {
              if (moment.tz.guess(true) != "America/New_York") {
                return 1 * 3600 * 1000;
              }
            })()
          },
          {
            type: "year",
            count: 1,
            text: "1Y",
            events: {
              click: () => {
                if (selectedFilter.value !== 3) {
                  initiateTracking("botEvents", "Account Summary", "", "1y");
                } else {
                }
                selectedFilter.value = 3;

                if (this.state.tabSelectedValue < selectedFilter.value) {
                  this.setState((state, props) => ({
                    tabSelectedValue: selectedFilter.value
                  }));
                  this.threeYearData(1);
                }
              }
            }
          },
          {
            type: "year",
            count: 3,
            text: "3Y",
            events: {
              click: () => {
                if (selectedFilter.value !== 4) {
                  initiateTracking("botEvents", "Account Summary", "", "3y");
                } else {
                }
                selectedFilter.value = 4;

                if (this.state.tabSelectedValue < selectedFilter.value) {
                  this.setState((state, props) => ({
                    tabSelectedValue: selectedFilter.value
                  }));
                  this.threeYearData(3);
                }
              }
            }
          },
          {
            type: "year",
            count: 5,
            text: "5Y",
            events: {
              click: () => {
                if (selectedFilter.value !== 5) {
                  initiateTracking("botEvents", "Account Summary", "", "5y");
                } else {
                }
                selectedFilter.value = 5;
                if (this.state.tabSelectedValue < selectedFilter.value) {
                  this.setState((state, props) => ({
                    tabSelectedValue: selectedFilter.value
                  }));
                  this.threeYearData(5);
                }
              }
            }
          }
        ],
        selected: selectedFilter.value,
        buttonTheme: {
          // styles for the buttons
          fill: "none",
          stroke: "none",
          "stroke-width": 0,
          r: 4,
          padding: 5,
          style: {
            fontFamily: "HelveticaNeue-Bold",
            fontWeight: "normal",
            fontSize: "16px",
            position: "absolute",
            textAlign: "center",
            color: "#606060",
            borderColor: "#000000"
          },
          states: {
            hover: {
              fill: "#0d504d",
              style: {
                color: "white",
                fontFamily: "HelveticaNeue-Bold",
                fontSize: "16px",
                paddingTop: "2px",
                fontWeight: "normal",
                fontStyle: "normal",
                textAlign: "center"
              }
            },
            select: {
              fill: "#0d504d",
              style: {
                color: "white",
                fontFamily: "HelveticaNeue-Bold",
                fontSize: "16px",
                paddingTop: "12px",
                fontWeight: "normal",
                fontStyle: "normal",
                fontStretch: "normal",
                lineHeight: "normal",
                letterSpacing: "normal",
                textAlign: "center"
              }
            },
            disabled: {
              fill: "#eaeaea",
              style: {
                fontFamily: "HelveticaNeue-Bold",
                fontSize: "16px",
                position: "absolute",
                fontStyle: "normal",
                fontStretch: "normal",
                lineHeight: "normal",
                letterSpacing: "normal",
                textAlign: "center",
                color: "#a5a5a5",
                fontWeight: "normal"
              }
            }
          }
        }
      },
      navigator: {
        enabled: true
      },

      yAxis: {
        opposite: false,
        maxPadding: 0.1,

        labels: (function() {
          let windowWidth = window.innerWidth;
          if (windowWidth > 767) {
            let obj = {
              style: {
                color: "#606060",
                fontFamily: "HelveticaNeue",
                fontSize: "16px"
              },

              formatter: function() {
                return "$" + this.axis.defaultLabelFormatter.call(this);
              }
            };
            return obj;
          } else {
            let obj = {
              align: "left",
              x: -10,
              y: -2,
              style: {
                color: "#606060",
                fontFamily: "HelveticaNeue",
                fontSize: "12px"
              },

              formatter: function() {
                return "$" + this.axis.defaultLabelFormatter.call(this);
              }
            };
            return obj;
          }
        })()
      },

      xAxis: {
        ordinal: false,

        labels: (function() {
          let windowWidth = window.innerWidth;
          if (windowWidth > 767) {
            let obj = {
              useHTML: true,

              style: {
                color: "#606060",
                fontFamily: "HelveticaNeue",
                fontSize: "16px",
                "text-align": "center"
              }
            };
            return obj;
          } else {
            let obj = {
              style: {
                color: "#606060",
                fontFamily: "HelveticaNeue",
                fontSize: "12px",
                "text-align": "center"
              }
            };
            return obj;
          }
        })(),

        type: "datetime",
        dateTimeLabelFormats: {
          millisecond: {
            main: "%H:%M:%S.%L",
            range: false
          },
          second: {
            main: "%H:%M:%S",
            range: false
          },
          minute: {
            main: "%H:%M",
            range: false
          },
          hour: {
            main: "%H:%M",
            range: false
          },
          day: {
            main: "%b %d "
          },
          week: {
            main: "%b %d "
          },
          month: {
            month: "%b '%y"
          },
          year: "%Y"
        }
      },

      plotOptions: {
        series: {
          turboThreshold: 0,
          cursor: "pointer",
          showInNavigator: true,
          fillOpacity: 0.4,
          lineWidth: 1.5,
          lineColor: "#136878",
          dataLabels: {
            crop: false,
            overflow: "allow"
          },

          states: {
            hover: {
              halo: {
                size: 9,
                opacity: 0.2,
                color: "#006778"
              }
            }
          }
        }
      },
      tooltip: {
        backgroundColor: "white",
        borderWidth: 1.5,
        borderColor: "#006778",
        shadow: false,
        useHTML: true,
        style: {
          padding: 20,
          color: "#4a4a4a"
        },
        formatter: function() {
          if (this.point) {
            return (
              "<div class='chart-annual-tooltip'>" +
              "<b>" +
              "<div class='chart-annual-heading'>Annual activity breakdown </div>" +
              "</b>" +
              "<div>" +
              moment(
                moment.tz(this.point.Annual.startDate, "America/New_York")
              ).format("L") +
              " " +
              "-" +
              " " +
              moment(
                moment.tz(this.point.Annual.endDate, "America/New_York")
              ).format("L") +
              "</div>" +
              "<div>Balance:" +
              "&nbsp" +
              "<b>" +
              "$" +
              Number(this.point.Annual.currentBalance).toLocaleString(
                undefined,
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              ) +
              "</b>" +
              "</div>" +
              "<div>Grants:" +
              "&nbsp" +
              "<b>" +
              "$" +
              Number(this.point.Annual.grants).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) +
              "</b>" +
              "</div>" +
              "<div>Contributions:" +
              "&nbsp" +
              "$" +
              "<b>" +
              Number(this.point.Annual.contribution).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) +
              "</b>" +
              "</div>" +
              "</div>"
            );
          } else {
            return (
              "<div class='bot-chart-tooltip'> " +
              "<div class='bot-chart-heading'>" +
              "<b>" +
              moment(moment.tz(this.x, "America/New_York")).format("L") +
              "</b>" +
              "</div>" +
              "<div>" +
              "Balance:" +
              "&nbsp" +
              "<b>" +
              "$" +
              Number(this.y).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) +
              "</b>" +
              "</div>" +
              "</div>"
            );
          }
        }
      },

      series: [
        {
          name: "BOT",

          data: this.handleData(this.state.data),
          id: "dataseries",
          color: "#d9e8eb"
        },
        {
          type: "flags",
          data: this.annualData(),

          shape: "squarepin",
          x: 20,
          rotation: 90,
          width: (function() {
            let windowWidth = window.innerWidth;
            if (windowWidth > 767) {
              return 100;
            } else {
              return 30;
            }
          })(),

          color: (function() {
            let windowWidth = window.innerWidth;
            if (windowWidth > 767) {
              return "white";
            } else {
              return "#006778";
            }
          })(), // same as onSeries
          fillColor: "#505050",
          onSeries: "dataseries",
          lineColor: "#505050",
          borderWidth: 1,
          borderColor: "red",
          style: {
            // text style
            color: "white",
            fontFamily: "HelveticaNeue-Bold",
            fontWeight: "normal",
            fontSize: (function() {
              let windowWidth = window.innerWidth;
              if (windowWidth > 767) {
                return "12px";
              } else {
                return "10px";
              }
            })(),
            textAlign: "center"
          },
          states: {
            hover: {
              fillColor: "#505050",
              color: "#006778",
              lineColor: "#505050", // darker
              style: {}
            }
          }
        }
      ]
    };
    return (
      <div>
        {this.state.BOTloader == true ? (
          <div>
            <div className="noDataPlacement chart-no-data">
              <div className="loader-position">
                <div>
                  <img alt="Loader" src={loader} className="mr-icon" />
                </div>
              </div>
            </div>
          </div>
        ) : this.state.chartDataMonth == false ? (
          <div className="noDataPlacement chart-no-data">
            <div>No data available for this date range.</div>
          </div>
        ) : (
          <div>
            <div className="view-range-text">View Range</div>
            <ReactHighcharts highcharts={Highcharts} data-test="highcharts" config={chartConfig} />
            <div className="range-selector-tooltipBOT">
              {this.props.botStatusText}
            </div>
          </div>
        )}
      </div>
    );
  }
}
export const mapDispatchToProps = dispatch => {
  return {
    fetchBOTData: data => dispatch(fetchBOTData(data))
  };
};
export const mapStateToProps = state => {
  return {
    ...accountSummaryDerivedStates(state.toJS())
  };
};
BOTChart.propTypes = {
  accountSummaryBalance_data_all: PropTypes.array,
  isAccountSummaryLoading: PropTypes.bool,
  botStatusText: PropTypes.string
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { pure: true }
)(BOTChart);
